import { useState } from "react";
import { T } from "react-translator-component";
import { colors } from "../../common/colors";
import SafeTextWithLinks from "../SafeTextWithLinks";

interface Props {
  description: string;
}

const TEXT_LIMIT_LENGTH = 80;

const PostDescSeeMore = ({ description }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };

  const renderDescription = () => {
    return (
      <div
        style={{
          fontSize: 14,
          marginLeft: 6,
          marginRight: 6,
          lineBreak: "anywhere",
        }}
      >
        <SafeTextWithLinks text={description} limit={isExpanded ? undefined : TEXT_LIMIT_LENGTH} />
        {description.length > TEXT_LIMIT_LENGTH && (
          <span
            style={{
              fontSize: 12,
              color: colors.farm_gray200,
              cursor: "pointer",
              display: "block", // Make sure the text stays on a new line if desired
              marginTop: 8, // Some space between the text and the "See more/less"
            }}
            onClick={toggleDescription}
          >
            {isExpanded ? T("shrink_display") : T("read_more")}
          </span>
        )}
      </div>
    );
  };

  return <div className="post">{renderDescription()}</div>;
};

export default PostDescSeeMore;
